import { SelectProps } from "@cofano/cck/Select/Select";
import { CargoQuantityUnit } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const CargoQuantityUnitSelect = ({ value, onChange }: Omit<SelectProps<CargoQuantityUnit, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(CargoQuantityUnit)}
			getOptionLabel={(option) => intl.formatMessage({ id: `CARGO_QUANTITY_UNIT_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default CargoQuantityUnitSelect;
